import classNames from 'classnames'
import { FormikProps } from 'formik'
import { formatDate, parseDateStringToDate } from '../../helpers'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import Icon from '../icon'
import { Checkbox } from '../inputs/Checkbox'
import { DateInput } from '../inputs/dateInput'
import Dropdown from '../inputs/dropdown'
import { TextInput } from '../inputs/textInput'
import { HeaderSubheader } from '../typography/HeaderSubheader'

const expirationReminderOptions = [
  {
    name: '1 month',
    value: '1_month',
  },
  {
    name: '3 months',
    value: '3_months',
  },
]

export const ManageProductExpiration = ({
  formik,
  className,
  typeTitle,
}: {
  formik: FormikProps<CreateProductValues>
  className?: string
  typeTitle: string
}) => {
  const { values, errors, setFieldValue, handleBlur, handleChange, touched } =
    formik

  return (
    <div
      className={classNames(
        'flex flex-col gap-6 pb-10 border-b border-divider-gray',
        className,
      )}
    >
      <HeaderSubheader
        title={`${typeTitle} Expiration`}
        text={`Configure ${typeTitle} expiration alert`}
      />

      <div className="flex flex-col gap-4 items-center max-w-[500px]">
        <Checkbox
          checkStatus={values.trackExpiry}
          text="Track product expiration"
          handleChange={(status) => {
            setFieldValue('trackExpiry', status)
          }}
          className="w-full"
        />

        {values.trackExpiry ? (
          <div className="grid grid-cols-2 gap-4 items-center">
            <DateInput
              name="bestBeforeDate"
              onBlur={handleBlur}
              placeholder="Select date"
              errors={
                errors.bestBeforeDate && touched.bestBeforeDate
                  ? errors.bestBeforeDate
                  : ''
              }
              title="Best Before Date"
              date={parseDateStringToDate(
                values.bestBeforeDate,
                'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
                true,
              )}
              setDate={(date) => {
                setFieldValue(
                  'bestBeforeDate',
                  formatDate(date, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
                )
              }}
              dateFormat="MMM DD, YYYY"
            />

            <Dropdown
              loading={false}
              className=""
              menuClassName="!max-h-[200px]"
              menuButton={
                <TextInput
                  type="text"
                  title="Reminder Interval"
                  name="expiryReminderInterval"
                  placeholder="Reminder Interval"
                  value={
                    expirationReminderOptions.find(
                      (v) => v.value === values.expiryReminderInterval,
                    )?.name
                  }
                  onBlur={handleBlur}
                  onChange={handleChange}
                  errors={
                    errors.expiryReminderInterval &&
                    touched.expiryReminderInterval
                      ? errors.expiryReminderInterval
                      : ''
                  }
                  hasIcon={false}
                  readOnly
                  extra={
                    <Icon
                      id={'left-caret'}
                      width={16}
                      height={16}
                      className="-rotate-90 text-sec-black"
                    />
                  }
                  className="!border-divider-gray"
                />
              }
              menuItems={expirationReminderOptions.map((opt) => ({
                ...opt,
                onClick: () => {
                  setFieldValue('expiryReminderInterval', opt.value)
                },
              }))}
            />
          </div>
        ) : undefined}
      </div>
    </div>
  )
}
